/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ihfdestt2nallcpr3ckluqk7aq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-l4pjq4jtq5h3rdaxhp3yjogp4e",
    "aws_cognito_identity_pool_id": "us-east-1:5806ab7a-0a5d-4f4c-bf31-59f1abf5f435",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_xhu1tTliU",
    "aws_user_pools_web_client_id": "2gb5jc8vb0k5ijvpier4apfqgr",
    "oauth": {
        "domain": "afiwebd808ffe8-d808ffe8-mainp.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://clientes.afisofom.com/",
        "redirectSignOut": "https://clientes.afisofom.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "afi-web-s3-bucket1205e-mainp",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
